import styled from "styled-components";

export const WordCloudWrapper = styled.div`
  width: 100%;
`;
